import path from 'utils/path';

export const routerPath = {
  root: '/Regions',
  link: '/settings/Regions',
  go_packages: (regionId) => path(`${regionId}`, '/packages'),
  go_personal_trainers_packages: (regionId) => path(`${regionId}`, '/personalTrainersPackages'),
  go_personal_trainers_commissions: (regionId) => path(`${regionId}`, '/personalTrainersCommissions'),
};

export const timeZones = [
  {
    label: 'UTC -12:00',
    value: -720,
  },
  {
    label: 'UTC -11:00',
    value: -660,
  },
  {
    label: 'UTC -10:00',
    value: -600,
  },
  {
    label: 'UTC -09:30',
    value: -570,
  },
  {
    label: 'UTC -09:00',
    value: -540,
  },
  {
    label: 'UTC -08:00',
    value: -480,
  },
  {
    label: 'UTC -07:00',
    value: -420,
  },
  {
    label: 'UTC -06:00',
    value: -360,
  },
  {
    label: 'UTC -05:00',
    value: -300,
  },
  {
    label: 'UTC -04:00',
    value: -240,
  },
  {
    label: 'UTC -03:30',
    value: -210,
  },
  {
    label: 'UTC -03:00',
    value: -180,
  },
  {
    label: 'UTC -02:00',
    value: -120,
  },
  {
    label: 'UTC -01:00',
    value: -60,
  },
  {
    label: 'UTC 0',
    value: 0,
  },
  {
    label: 'UTC +01:00',
    value: 60,
  },
  {
    label: 'UTC +02:00',
    value: 120,
  },
  {
    label: 'UTC +03:00',
    value: 180,
  },
  {
    label: 'UTC +03:30',
    value: 210,
  },
  {
    label: 'UTC +04:00',
    value: 240,
  },
  {
    label: 'UTC +04:30',
    value: 270,
  },
  {
    label: 'UTC +05:00',
    value: 300,
  },
  {
    label: 'UTC +05:30',
    value: 330,
  },
  {
    label: 'UTC +05:45',
    value: 345,
  },
  {
    label: 'UTC +06:00',
    value: 360,
  },
  {
    label: 'UTC +06:30',
    value: 390,
  },
  {
    label: 'UTC +07:00',
    value: 420,
  },
  {
    label: 'UTC +08:00',
    value: 480,
  },
  {
    label: 'UTC +08:45',
    value: 525,
  },
  {
    label: 'UTC +09:00',
    value: 540,
  },
  {
    label: 'UTC +09:30',
    value: 570,
  },
  {
    label: 'UTC +10:00',
    value: 600,
  },
  {
    label: 'UTC +10:30',
    value: 630,
  },
  {
    label: 'UTC +11:00',
    value: 660,
  },
  {
    label: 'UTC +12:00',
    value: 720,
  },
  {
    label: 'UTC +12:45',
    value: 765,
  },
  {
    label: 'UTC +13:00',
    value: 780,
  },
  {
    label: 'UTC +14:00',
    value: 840,
  },
];

export const getColumns = ({ editItem, packages, personalTrainersPackages, personalTrainersCommissions }) => [
  { id: 'region', label: 'Region', align: 'left' },
  {
    id: 'timeZoneOffset',
    label: 'Time Zone',
    customValue: (data) => timeZones.find((item) => item.value === data?.timeZoneOffset)?.label || '-',
    align: 'center',
  },
  { id: 'country', label: 'Country', align: 'center' },
  { id: 'currency', label: 'Currency', align: 'center', sx: { textTransform: 'uppercase' } },
  { id: 'subscriptionCost', label: 'Sub Cost', align: 'center' },
  { id: 'classCreditValue', label: 'Credit Value', align: 'center' },
  { id: 'redeemableAmount', label: 'Redeemable amount', align: 'center' },
  {
    id: 'isFranchise',
    label: 'Is Franchise',
    customValue: (data) => (data?.isFranchise ? 'True' : 'False'),
    align: 'center',
  },
  {
    id: 'franchiseSuspended',
    label: 'Franchise Suspended',
    customValue: (data) => (data?.franchiseSuspended ? 'True' : 'False'),
    align: 'center',
  },
  { id: 'coinValue', label: 'Coin Value', align: 'center' },
  { id: 'creditRation', label: 'Credit Ratio', align: 'center' },
  { id: 'coinsToVoucherOwner', label: 'Coins to voucher owner', align: 'center' },
  { id: 'coinsToVoucherUser', label: 'Coins to voucher user', align: 'center' },
  { id: 'transactionFee', label: 'Transaction Fee', align: 'center' },
  { id: 'valueAddedTax', label: 'VAT', align: 'center' },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      { id: 1, name: 'Edit', action: editItem, icon: 'eva:edit-fill' },
      { id: 2, name: 'Packages', action: packages, icon: 'mdi:text-box-multiple-outline' },
      {
        id: 3,
        name: 'PT Packages',
        action: personalTrainersPackages,
        icon: 'mdi:text-box-multiple-outline',
      },
      {
        id: 4,
        name: 'PT Commissions',
        action: personalTrainersCommissions,
        icon: 'mdi:text-box-multiple-outline',
      },
    ],
    disableSort: true,
  },
];
